import { TallSeparator, InsetBorderContainer, Border } from './styles.js';
import { SeparatorVerticalMargin, SeparatorInset } from './constants.js';
import { ThemingContext, Spacing } from '@doordash/design-language';
import React from 'react';
import { SeparatorSize, SeparatorType } from './types.js';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InsetBorder = function InsetBorder(props) {
  return /*#__PURE__*/React.createElement(InsetBorderContainer, props, /*#__PURE__*/React.createElement(Border, props));
};

var Separator = function Separator(_ref) {
  var _ref$separatorHeight = _ref.separatorHeight,
      separatorHeight = _ref$separatorHeight === void 0 ? SeparatorSize.Small : _ref$separatorHeight,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? SeparatorType.Separator : _ref$type,
      _ref$verticalMargin = _ref.verticalMargin,
      verticalMargin = _ref$verticalMargin === void 0 ? SeparatorVerticalMargin.None : _ref$verticalMargin,
      _ref$inset = _ref.inset,
      inset = _ref$inset === void 0 ? SeparatorInset.Small : _ref$inset,
      props = _objectWithoutProperties(_ref, ["separatorHeight", "type", "verticalMargin", "inset"]);

  var theme = React.useContext(ThemingContext);

  switch (type) {
    case SeparatorType.InsetBorder:
      return /*#__PURE__*/React.createElement(InsetBorder, _extends({
        backgroundColor: theme.Colors.BorderPrimary,
        verticalMargin: verticalMargin,
        inset: inset
      }, props));

    case SeparatorType.FullBorder:
      return /*#__PURE__*/React.createElement(InsetBorder, _extends({
        backgroundColor: theme.Colors.BorderPrimary,
        verticalMargin: verticalMargin,
        inset: Spacing.None
      }, props));

    case SeparatorType.Tall:
    default:
      return /*#__PURE__*/React.createElement(TallSeparator, _extends({
        backgroundColor: theme.Colors.PageBackgroundSecondary,
        borderColor: theme.Colors.BorderPrimary,
        separatorHeight: separatorHeight,
        verticalMargin: verticalMargin
      }, props));
  }
};

Separator.Types = SeparatorType;
Separator.Sizes = SeparatorSize;

export { Separator as default };
